module.exports = __webpack_public_path__ + "static/media/21_blanco.af50952a.svg";